import Field from "@mirage/components/regularField/Field";
import Grid from "@mui/material/Grid";
import { IEnforcementNoticeDetails } from "@shared/publicportal/contracts/IEnforcementNoticeDetails";
import React from "react";

interface ENoticeSummaryTabProps {
    notice: IEnforcementNoticeDetails | null;
    loading: boolean;
}

const ENoticeSummaryTab: React.FC<ENoticeSummaryTabProps> = (props) => {
    const { notice, loading } = props;
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12 }}>
                <Grid>
                    <Field label="Notice Reference" mode="view" value={notice?.name} isLoading={loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field mode="view" label="Date Created" value={notice?.dateCreated} isLoading={loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field mode="view" label="Compliance Deadline" value={notice?.complianceDeadline} isLoading={loading} contentType="DATE" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Complaint Reference" mode="view" readOnly value={notice?.enforcementReference?.name} isLoading={loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field label="Notice Status" mode="view" readOnly value={notice?.noticeStatus} isLoading={loading} contentType="TEXT" hideOnEmpty />
                </Grid>
                <Grid>
                    <Field mode="view" label="Served On" value={notice?.servedOn} isLoading={loading} contentType="DATE" hideOnEmpty />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ENoticeSummaryTab;
